module.exports = __SOFIPO_BASE_DLL__.ReactJsxRuntime;